import React, { useEffect } from 'react';
import InbankBanner from '../../../images/inbank_banner.svg';
import InbankMakseviis from '../../../images/inbank_makseviis_mobile.svg';
import InbankTaotlemine from '../../../images/inbank_taotlemine_mobile.svg';
import Makseviis from '../../../images/inbank_makseviis.svg';
import Taotlemine from '../../../images/inbank_taotlemine.svg';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';

export default function Inbank() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="my-4 lg:my-12 md:max-w-2xl lg:max-w-4xl">
        <div className="md:mb-10">
          <button
            className="hidden md:flex md:w-32 py-2 px-4 bg-rgreen text-white rounded md:items-center md:mr-auto"
            type="button"
            onClick={() => window.history.back()}
            aria-label="Tagasi"
          >
            <ChevronLeftIcon className="w-5 h-5 m-1" aria-hidden="true" />
            <span className="text-sm mx-2">Tagasi</span>
          </button>
        </div>
        <div className="flex flex-col items-center justify-center">
          <div className="md:bg-rgrey-lightborder md:rounded-lg md:p-6">
            <img
              src={InbankBanner}
              alt="Inbank"
              className="w-full h-auto object-cover rounded-lg"
              aria-label="Inbank"
            />
            <div className="my-10 md:my-16 md:px-6 lg:px-16">
              <div className="text-4xl font-axi-bold mb-5 md:mb-6">
                Inbanki makseviisid
              </div>
              <div className="text-base mb-4 md:mb-5">
                Inbanki makseviisid aitavad ostude eest veelgi mugavamalt
                tasuda. Tasu oma ostu eest alles järgmisel kuul või jaga
                ostusumma kolmeks võrdseks osaks, lihtsalt ja ilma ühegi
                lisatasuta. Leia sobiv makselahendus kassast ja vali endale
                sobivaim järgmistest valikutest.
              </div>
              <div className="text-base font-axi-bold mb-3 mb:mb-4">
                Inbank jaga osadeks:
              </div>
              <div className="ml-3 mb-7 md:mb-9">
                <ul className="text-base mx-4 space-y-2 list-disc">
                  <li>Maksa 3 võrdses osas</li>
                  <li>75 – 2500 € ostudele</li>
                  <li>0 € lisatasu</li>
                </ul>
              </div>
              <div className="text-2xl font-axi-bold mb-3 md:mb-4">
                Miks valida Inbanki makseviis?
              </div>
              <div className="ml-3 mb-8 md:mb-9">
                <ul className="text-base mx-4 space-y-2 list-disc">
                  <li>
                    Lihtne ja lisatasudeta - pole intressi, lepingutasu ega
                    igakuist haldustasu.
                  </li>
                  <li>
                    Nutikas viis soetada kohe kõik, mida vajad, tegemata
                    valikute arvelt järeleandmisi. Maksmist alustad alles
                    järgmisel kuul.
                  </li>
                  <li>
                    Inbanki maksa hiljem makseviiside puhul ei ole tegu
                    järelmaksuga, vaid krediidivabade makseviisidega – need ei
                    mõjuta sinu krediidiskoori.
                  </li>
                </ul>
              </div>
              <div className="text-2xl font-axi-bold mb-4 md:mb-5">
                Inbanki makseviisiga tasumine on lihtne!
              </div>
              <img
                src={InbankMakseviis}
                alt="Inbank makseviisiga tasumine"
                className="w-56 md:hidden h-auto object-cover rounded-lg mb-4"
                aria-label="Inbank makseviisiga tasumine"
              />
              <img
                src={Makseviis}
                alt="Inbank makseviisiga tasumine"
                className="hidden md:block md:w-full h-auto object-cover rounded-lg mb-6"
                aria-label="Inbank makseviisiga tasumine"
              />
              <div className="text-lg mb-8 md:mb-16">
                Ost kinnitatakse vaid mõne hetkega.
              </div>
              <div className="text-4xl font-axi-bold mb-5 md:mb-6">
                Inbanki järelmaks
              </div>
              <div className="text-base mb-4 md:mb-5">
                Inbanki järelmaks võimaldab sul muuta suur ühekordne väljaminek
                igakuiseks väikeseks kuluks ning tasuda toodete ja teenuste eest
                osade kaupa. Võta maksmiseks rohkem aega ning jaga ostusumma
                kuni 5 aasta peale. Esimene makse alles kuu aja pärast.
              </div>
              <div className="text-base font-axi-bold mb-3 md:mb-4">
                Inbanki järelmaksu eelised:
              </div>
              <div className="ml-3 mb-4 md:mb-5">
                <ul className="text-base mx-4 space-y-2 list-disc">
                  <li>Paindlik lahendus suuremateks väljaminekuteks</li>
                  <li>Sina valid järelmaksu summa suuruse</li>
                  <li>Sina valid järelmaksu perioodi</li>
                  <li>Sina valid maksekuupäeva</li>
                  <li>Vastus taotlusele minutiga</li>
                </ul>
              </div>
              <div className="text-base font-axi-bold mb-3 md:mb-4">
                Inbanki järelmaksu tingimused:
              </div>
              <div className="ml-3 mb-8 md:mb-9">
                <ul className="text-base mx-4 space-y-2 list-disc">
                  <li>Summa 100 - 10 000 €</li>
                  <li>Periood 3 - 72 kuud</li>
                  <li>Sissemakse 0 €</li>
                  <li>Intress 11,9 %</li>
                  <li>Haldustasu 0,9 €</li>
                </ul>
              </div>
              <div className="text-2xl font-axi-bold mb-4 md:mb-5">
                Järelmaksu taotlemine on lihtne
              </div>
              <img
                src={InbankTaotlemine}
                alt="Inbank järelmaksu taotlemine"
                className="w-56 md:hidden h-auto object-cover rounded-lg mb-8"
                aria-label="Inbank järelmaksu taotlemine"
              />
              <img
                src={Taotlemine}
                alt="Inbank järelmaksu taotlemine"
                className="hidden md:block md:w-full h-auto object-cover rounded-lg mb-7"
                aria-label="Inbank järelmaksu taotlemine"
              />
              <div className="text-sm mb-6">
                Inbanki järelmaksu krediidi kulukuse määr on 25,79 % aastas
                järgmistel näidistingimustel: järelmaksu summa 2000 €,
                lepinguperiood kuudes 24, intressimäär 11,9 % ostusummalt,
                sissemakse 0 %, haldustasu 0,9 €, igakuine osamakse 104,96 €,
                krediidi kogukulu 2519 €. Teenuse pakkujaks on AS Inbank
                Finance. Enne lepingu sõlmimist soovitame sul tutvuda
                finantsteenuse tingimustega ja vajadusel konsulteerida
                spetsialistiga.
              </div>
              <div>
                <button
                  className="md:hidden w-full py-2 px-4 bg-rgreen text-white rounded flex items-center justify-center"
                  type="button"
                  onClick={() => window.history.back()}
                  aria-label="Tagasi"
                >
                  <ChevronLeftIcon className="w-5 h-5 m-1" aria-hidden="true" />
                  <span className="text-sm mx-2">Tagasi</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
